export const GRID_STEP = 2
export const GRID_SIZE = 20
export const BOOTH_COLOR = '#8D7F6A'
export const BOX_TYPES = ['booth', 'rect', 'image']
